import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useDemoData } from "@/hooks/useDemoData";

export default function BidModal({
  loadId,
  onClose,
}: {
  loadId: string;
  onClose: () => void;
}) {
  const { loads, addBid } = useDemoData();
  const [amount, setAmount] = useState("");
  const load = loads.find((l) => l.id === loadId);
  const submit = () => {
    addBid({
      id: Date.now().toString(),
      loadID: loadId,
      carrierID: "",
      amount: +amount,
      status: "Pending",
      createdAt: new Date().toISOString(),
    });
    onClose();
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Place Bid - {load?.id}</DialogTitle>
          <DialogDescription>Enter your bid amount</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Input
            placeholder="Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={submit}>Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
